<template>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Groups Table</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-btn style="float:right;color:white" variant="light">Add Group</b-btn>
            </b-col>

          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            hover
            outlined
            responsive
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(name)="row">
              {{ row.item.firstName }} {{ row.item.lastName }}
            </template>

            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? 'text-success' : 'bg-danger btn-sm'" style="text-align: center;">{{ row.item.status }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="primary" size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                Edit
              </b-button>
              <b-button variant="outline-dark" size="sm" @click="row.toggleDetails">
                Remove
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
      </div>
    </div>

</template>

<script>
export default {
  data () {
    return {
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    // Set the initial number of items
    this.totalRows = this.$store.state.users.length
    this.$store.dispatch('fetchUsers')
    // this.mapUsers()
    console.log(this.$store.state.users)
  },
  methods: {
    info (item, index, button) {
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    mapUsers () {
      // var self = this;
      // this.$store.state.users.forEach(function (user) {
      //
      //   self.users =
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GroupForm.vue